<script lang="ts">
  import { onMount, untrack } from "svelte";
  import { recordInteraction, resolveInteractionsPath, setEvents, type Interaction} from "../lib/interactions.svelte"

  let {
    interactions,
    interactions_path
  } : {
    interactions: Interaction[];
    interactions_path: string;
  } = $props()

  // Make path available to recordInteraction
  onMount(() => resolveInteractionsPath(interactions_path))

  // Keep global interactions state up to date with interactions prop passed to this component
  $effect(() => {
    interactions.length // Re-run effect on turbo stream append (svelte_patch)
    untrack(()=>setEvents(interactions))
  })

  // Log clicks on elements with data-interaction="<< signed interaction >>"
  const attribute = "data-interaction"
  function recordInteractionOnClick(event: MouseEvent) {
    const interactor = (event.target as Element)?.closest(`[${attribute}]`);
    if (event.defaultPrevented || !interactor) return;
    const signedInteraction = interactor.getAttribute(attribute);
    recordInteraction(signedInteraction);
  }
</script>
<svelte:window onclick={recordInteractionOnClick} />
